module.exports = __webpack_public_path__ + "c355de0fd65b2d6fd79ece9fc62aff47.svg";